import { SortingExpression, SqlOptions } from '../types';
import { findColumnName } from './find-column';

export default function sortingBuilder(
  sqlOptions: SqlOptions,
): SortingExpression[] {
  const expressions: SortingExpression[] = [];
  sqlOptions.sortingInstructions?.forEach((sort) => {
    expressions.push({
      direction: sort.desc ? 'desc' : 'asc',
      field: findColumnName(sqlOptions, sort.id),
    });
  });

  return expressions;
}
